module.exports = __webpack_public_path__ + "img/2.bbeee6b1.png";